import { t } from 'i18next';
import { useState } from 'react';
import type { Control } from 'react-hook-form';
import { Controller } from 'react-hook-form';

type FatBonesFormProps = {
  control: Control<any, any>;
  errors: any;
  stop: any;
  barrelSize: number;
  setDisplayBarrelSize: (value: string) => void;
};

export const FatBonesForm = ({
  control,
  errors,
  stop,
  barrelSize,
  setDisplayBarrelSize,
}: FatBonesFormProps) => {
  const [displayValue, setDisplayValue] = useState<string>('');
  const [displayDropped, setDisplayDropped] = useState('');

  return (
    <div className="flex flex-col gap-2">
      <span className="">
        <p className="text-sm text-ReyesBlack">
          {t('manifest.currentBarrels')}
        </p>
        <p className="text-sm text-ReyesGrey">{stop.estimated_barrel}</p>
      </span>
      <span>
        <p className="text-sm text-ReyesBlack">
          {t('manifest.barrelsPickedUp')}
        </p>
        <Controller
          name="barrelsPickedUp"
          control={control}
          rules={{
            required: `${t('manifest.error2')}`,
            pattern: /^[0-9]*$/,
            maxLength: 10,
          }}
          render={({ field }) => (
            <>
              <input
                type="number"
                id="barrelsPickedUp"
                {...field}
                style={{ display: 'none' }}
              />
              <input
                className="w-full border-b-2 border-ReyesGreyLight bg-transparent text-sm text-ReyesGrey focus:outline-none"
                type="text"
                id="barrelsPickedUpDisplay"
                value={displayValue}
                maxLength={10}
                onChange={(e) => {
                  const numberValue = Number(e.target.value.replace(/,/g, ''));
                  if (!Number.isNaN(numberValue)) {
                    field.onChange(numberValue);
                    setDisplayValue(String(numberValue));
                  }
                }}
                style={{
                  appearance: 'none',
                  MozAppearance: 'textfield',
                }}
              />
            </>
          )}
        />
        {errors.barrelsPickedUp && (
          <>
            <br />
            <span className="text-red-500">
              {errors.barrelsPickedUp.message}
            </span>
          </>
        )}
      </span>
      <span>
        <p className="text-sm text-ReyesBlack">
          {t('manifest.barrelsDropped')}
        </p>
        <Controller
          name="barrelsDropped"
          control={control}
          rules={{
            required: `${t('manifest.error2')}`,
            pattern: /^[0-9]*$/,
            maxLength: 10,
          }}
          render={({ field }) => (
            <>
              <input
                type="number"
                id="barrelsDropped"
                {...field}
                style={{ display: 'none' }}
              />
              <input
                className="w-full border-b-2 border-ReyesGreyLight bg-transparent text-sm text-ReyesGrey focus:outline-none"
                type="text"
                id="barrelsDroppedDisplay"
                value={displayDropped}
                maxLength={10}
                onChange={(e) => {
                  const numberValue = Number(e.target.value.replace(/,/g, ''));
                  if (!Number.isNaN(numberValue)) {
                    field.onChange(numberValue);
                    setDisplayDropped(String(numberValue));
                  }
                }}
                style={{
                  appearance: 'none',
                  MozAppearance: 'textfield',
                }}
              />
            </>
          )}
        />
        {errors.barrelsDropped && (
          <>
            <br />
            <span className="text-red-500">
              {errors.barrelsDropped.message}
            </span>
          </>
        )}
      </span>
      <span>
        <p className="text-sm text-ReyesBlack">{t('manifest.barrelSize')}</p>
        <Controller
          name="barrelSize"
          control={control}
          rules={{
            required: `${t('manifest.error2')}`,
            pattern: /^[0-9]*$/,
            maxLength: 10,
          }}
          render={({ field }) => (
            <>
              <input
                type="number"
                id="barrelSize"
                {...field}
                style={{ display: 'none' }}
              />
              <input
                className="w-full border-b-2 border-ReyesGreyLight bg-transparent text-sm text-ReyesGrey focus:outline-none"
                type="text"
                id="barrelSizeDisplay"
                value={barrelSize}
                maxLength={10}
                onChange={(e) => {
                  const numberValue = Number(e.target.value.replace(/,/g, ''));
                  if (!Number.isNaN(numberValue)) {
                    field.onChange(numberValue);
                    setDisplayBarrelSize(String(numberValue));
                  }
                }}
                style={{
                  appearance: 'none',
                  MozAppearance: 'textfield',
                }}
              />
            </>
          )}
        />
        {errors.barrelSize && (
          <>
            <br />
            <span className="text-red-500">{errors.barrelSize.message}</span>
          </>
        )}
      </span>
    </div>
  );
};
